<template>
  <div id="app">
    
    <wh10 msg="Welcome to Your Vue.js App"/>
  </div>
</template>

<script>
import wh10 from './components/wh10.vue'

export default {
  name: 'App',
  components: {
    wh10
  },
    watch: {
    '$route': function(){
document.body.scrollTop = 0
document.documentElement.scrollTop = 0

    }
	}
}
</script>

<style>
html, body, div, span, applet, object, iframe,
h1, h2, h3, h4, h5, h6, p, blockquote, pre,
a, abbr, acronym, address, big, cite, code,
del, dfn, em, img, ins, kbd, q, s, samp,
small, strike, strong, sub, sup, tt, var,
b, u, i, center,
dl, dt, dd, ol, ul, li,
fieldset, form, label, legend,
table, caption, tbody, tfoot, thead, tr, th, td,
article, aside, canvas, details, embed, 
figure, figcaption, footer, header, hgroup, 
menu, nav, output, ruby, section, summary,
time, mark, audio, video {
	margin: 0;
	padding: 0;
	border: 0;
	font-size: 100%;
	font: inherit;
	vertical-align: baseline;
}
/* HTML5 display-role reset for older browsers */
article, aside, details, figcaption, figure, 
footer, header, hgroup, menu, nav, section {
	display: block;
}

ol, ul {
	list-style: none;
}
blockquote, q {
	quotes: none;
}
blockquote:before, blockquote:after,
q:before, q:after {
	content: '';
	content: none;
}
html,body{
	width: 100%;
	min-width: 1400px;
}
/* #app{
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
} */
table {
	border-collapse: collapse;
	border-spacing: 0;
}
body{
	font-family: 'Microsoft Yahei', Tahoma, Arial, Helvetica, Simsun, STHeiti;
}
</style>
